var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodInox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6433_2453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.47412 52.9126C2.56119 56.804 5.75162 59.9434 9.66357 59.9434H27.1873L25.9272 52.9126H2.47412Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8106 29.9443H15.0679C8.5167 29.9443 3.11834 34.971 2.5249 41.3698H23.8583L21.8106 29.9443Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4676 44.7686H2.37293C1.06242 44.7686 0 45.8309 0 47.1414C0 48.4519 1.06242 49.5143 2.37293 49.5143H25.3181L24.4676 44.7686Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0981 55.9773C35.246 55.9773 31.0149 53.5156 28.8389 49.895L30.6391 59.9396H49.2623L51.1394 50.2419C48.9066 53.6717 44.7935 55.9773 40.0981 55.9773Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0984 52.3926C45.1983 52.3926 49.3325 48.7844 49.3325 44.3335C49.3325 39.8826 45.1983 36.2744 40.0984 36.2744C34.9985 36.2744 30.8643 39.8826 30.8643 44.3335C30.8643 48.7844 34.9985 52.3926 40.0984 52.3926Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4768 42.2949C28.5412 36.8434 33.7957 32.6904 40.0982 32.6904C46.3602 32.6904 51.5871 36.7906 52.6979 42.1904L55.5909 27.2441H24.7793L27.4768 42.2949Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0001 3.57227V0.0566406H47.5026L44.8083 15.76H27.2789L25.9692 20.213H20.3911V23.7285L60.0001 23.7286V20.213H54.422L53.1123 15.76H48.3753L50.4665 3.57227H60.0001Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6433_2453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodInox);
export default __webpack_public_path__ + "static/media/food-inox.4c5910e05a7f9f6b533704aa8f66b323.svg";
export { ForwardRef as ReactComponent };